import { matchPath, Outlet, useLocation } from "react-router";

import { PageHeader } from "@/components/page-header";
import { ROUTES } from "@/constants/routes";
import { usePageMeta } from "@/hooks/usePageMeta";
import { cx } from "@/utils/cx";

import { Sidebar } from "./Sidebar";

/**
 * App shell aligned with the dashboard `MainLayout`: brand sidebar column +
 * white main with rounded left edge and sticky page header.
 *
 * There is no "no access" state for the app as a whole: signing in to the
 * Shadow Realm Kinde environment is itself the authorization, so anyone who
 * gets this far is internal staff or an invited configurator. What they can
 * act on is the organization list, and which menu items they see is the
 * `globalAccess` grant — both from their ShadowAccess record.
 */
export const ShadowLayout = () => {
	const { description, title } = usePageMeta();
	const { pathname } = useLocation();
	const isLocationManagement = Boolean(
		matchPath({ end: true, path: ROUTES.ORGANIZATION_LOCATIONS }, pathname) ||
		matchPath({ end: true, path: ROUTES.ORGANIZATION_LOCATION }, pathname),
	);

	return (
		<div className="flex h-dvh flex-col bg-linear-45 from-linear-secondary to-linear-primary lg:flex-row">
			<Sidebar />

			<main className="scrollbar-hide flex min-h-0 min-w-0 flex-1 flex-col overflow-auto bg-primary lg:h-dvh lg:rounded-l-4xl lg:rounded-b-none">
				<PageHeader description={description} title={title} />
				<div className="flex min-h-0 flex-1 overflow-hidden">
					<div
						className={cx(
							"relative flex w-full flex-col",
							isLocationManagement
								? "min-h-0 flex-1 overflow-hidden px-0 pt-0"
								: "scrollbar-hide max-h-(--page-content-height) overflow-y-auto px-6 pt-6 lg:px-12 lg:pt-8",
						)}
					>
						<Outlet />
					</div>
				</div>
			</main>
		</div>
	);
};
